import { render } from "./FooterBank.vue?vue&type=template&id=4fdf1c22&scoped=true&ts=true"
import script from "./FooterBank.vue?vue&type=script&lang=ts"
export * from "./FooterBank.vue?vue&type=script&lang=ts"

import "./FooterBank.vue?vue&type=style&index=0&id=4fdf1c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdf1c22"]])

export default __exports__